var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"color":"green","dark":"","outlined":""},on:{"click":_vm.exportDataToExcel}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-file-excel-outline")]),_vm._v("Xuất Excel")],1)}
var staticRenderFns = []

export { render, staticRenderFns }